var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3339_15595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65007 8.12675C9.88226 7.97196 10.1691 7.8336 10.5 7.72651L10.5 10.2735C10.1691 10.1664 9.88227 10.028 9.65007 9.87325C9.10391 9.50913 9 9.17085 9 9C9 8.82915 9.10391 8.49087 9.65007 8.12675Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.2735L13.5 13.7265C13.8309 13.8336 14.1178 13.972 14.35 14.1268C14.8961 14.4909 15 14.8292 15 15C15 15.1709 14.8961 15.5091 14.35 15.8732C14.1178 16.028 13.8309 16.1664 13.5 16.2735Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5V4.63799C9.5676 4.81309 8.70522 5.15111 7.98597 5.6306C6.90345 6.35228 6 7.514 6 9C6 10.486 6.90345 11.6477 7.98597 12.3694C8.70522 12.8489 9.56761 13.1869 10.5 13.362L10.5 16.2739C9.91352 16.0834 9.47876 15.7979 9.235 15.5169C8.69207 14.8912 7.7447 14.8241 7.11898 15.367C6.49327 15.91 6.42617 16.8574 6.9691 17.4831C7.81283 18.4554 9.08933 19.0963 10.5 19.3615L10.5 19.5C10.5 20.3284 11.1715 21 12 21C12.8284 21 13.5 20.3285 13.5 19.5L13.5 19.362C14.4324 19.1869 15.2948 18.8489 16.0141 18.3694C17.0966 17.6477 18 16.486 18 15C18 13.514 17.0966 12.3523 16.014 11.6306C15.2948 11.1511 14.4324 10.8131 13.5 10.638L13.5 7.72613C14.0865 7.91656 14.5213 8.20214 14.765 8.48307C15.308 9.10878 16.2553 9.17588 16.881 8.63295C17.5068 8.09002 17.5739 7.14265 17.0309 6.51693C16.1872 5.54455 14.9107 4.90373 13.5 4.63854V4.5Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3339_15595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddonIcon);
export default __webpack_public_path__ + "static/media/addonIcon.879d250b341e44443e5766cb57f1d42b.svg";
export { ForwardRef as ReactComponent };